/**
  * Open Modal javscript trigger
  *
  * */
function globalJsRollbar(context, err, extra) {
  if (!window.Rollbar) return;
  try {
    const message =
      err && typeof err === 'object' && err.message
        ? String(err.message)
        : typeof err === 'string'
          ? err
          : 'global.js error';
    Rollbar.error(message, err instanceof Error ? err : { detail: err }, {
      context: 'global.' + context,
      ...(extra && typeof extra === 'object' ? extra : {}),
    });
  } catch (_) {}
}

function wrapGlobalClassPrototype(Ctor, className) {
  if (!Ctor || !Ctor.prototype) return;
  const proto = Ctor.prototype;
  Object.getOwnPropertyNames(proto).forEach((name) => {
    if (name === 'constructor') return;
    const desc = Object.getOwnPropertyDescriptor(proto, name);
    if (!desc || typeof desc.value !== 'function') return;
    const original = desc.value;
    proto[name] = function globalJsWrapped(...args) {
      try {
        const result = original.apply(this, args);
        if (result != null && typeof result.then === 'function') {
          return result.catch((e) => {
            globalJsRollbar(`${className}.${name}`, e);
            return Promise.reject(e);
          });
        }
        return result;
      } catch (e) {
        globalJsRollbar(`${className}.${name}`, e);
        throw e;
      }
    };
  });
}

function openModal(modal, opener) {
  try {
    if (modal && opener != undefined) modal.show(opener);
  } catch (e) {
    globalJsRollbar('openModal', e);
  }
}

function updateCartCountInHeader() {
  try {
    const count = window.globalSpace?.cart?.item_count ?? 0;
    const desktopCartCount = document.querySelector(`#cart-icon-desktop .cart-count`);
    const mobileCartCount = document.querySelector(`#cart-icon-mobile .cart-count`);

    if (desktopCartCount) {
      desktopCartCount.innerHTML = count;
      desktopCartCount?.classList.toggle('d-none', count === 0);
    }
    if (mobileCartCount) {
      mobileCartCount.innerHTML = count;
      mobileCartCount?.classList.toggle('d-none', count === 0);
    }
  } catch (e) {
    globalJsRollbar('updateCartCountInHeader', e);
  }
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    try {
      this.dropdown = element;
      this.toggleCTA = element.querySelector('.dropdown-toggle');
      this.supportedEvents = ['click', 'touchend', 'mouseenter', 'mouseleave', 'focusout'];
      this.init();
    } catch (e) {
      globalJsRollbar('Dropdown.constructor', e);
    }
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          evt.preventDefault();
          this.toggleDropdown();
        });
      } else if(type === 'mouseenter') {
        this.toggleCTA.addEventListener(type, (evt) => {
            this.dropdownShow(this.dropdown);
        });
        this.toggleCTA.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdown);
        });
      } else if(type === 'mouseleave') {
        this.dropdown.addEventListener(type, (evt) => {
          this.dropdownHide(this.dropdown);
        });
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.slideout-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
wrapGlobalClassPrototype(Dropdown, 'Dropdown');
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  try {
    new Dropdown(ele);
  } catch (e) {
    globalJsRollbar('Dropdown.bootstrap', e);
  }
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    try {
      this.overlayElement = document.querySelector('#site-overlay');
      this.bindEvents();
    } catch (e) {
      globalJsRollbar('SiteOverlay.constructor', e);
    }
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    const overlay = document.querySelector('#site-overlay');
    if (overlay) {
      overlay.classList.add('overlay--body');
      overlay.setAttribute('aria-hidden', false);
    }
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    const overlay = document.querySelector('#site-overlay');
    if (overlay) {
      overlay.classList.remove('overlay--body');
      overlay.setAttribute('aria-hidden', true);
    }
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
wrapGlobalClassPrototype(SiteOverlay, 'SiteOverlay');
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();
    try {
      this.type = this.getAttribute('data-video-type');
      this.videoURL = this.getAttribute('data-video-id');
      this.placementType = this.getAttribute('data-placement');
      this.videoStatus = 'empty';

      this.container = this.closest('.custom-video-container');
      this.videoModal = document.getElementById('PopupModal-video');
      this.contentSection = this.querySelector('.content-section');
      this.videoSection = this.querySelector('.video-section');
      if (this.placementType == 'popup' && this.videoModal) {
        this.videoSection = this.videoModal.querySelector('.video-container');
      }
      this.triggerVideo =
        this.querySelector('[data-trigger-video]') ||
        (this.container && this.container.querySelector('[data-trigger-video]'));
    } catch (e) {
      globalJsRollbar('CustomVideo.constructor', e);
    }
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection.setAttribute('aria-hidden', 'false');
        if(this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      video.autoplay = true;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
      // &playlist=${videoID}
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this){
    const elementIntersection = (entries) => {
      if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }
}
wrapGlobalClassPrototype(CustomVideo, 'CustomVideo');
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    try {
      this.modal = this.querySelector('.modal');
      this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
      this.closeBtn = this.querySelector('[id^="ModalClose-"]');
    } catch (e) {
      globalJsRollbar('ModalDialog.constructor', e);
    }
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
wrapGlobalClassPrototype(ModalDialog, 'ModalDialog');
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();
    try {
      this.container = this.querySelector('.snotifyToast');
      this.closeBtn = this.querySelector('.snotifyToast__close');
      this.viewCartBtn = this.querySelector('.snotifyToast__view-cart');
      this.animateNotifcation = null;
      if (this.container) {
        this.container.setAttribute('role', 'alert');
      }
    } catch (e) {
      globalJsRollbar('ToastNotification.constructor', e);
    }
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
    
    if (this.viewCartBtn) {
      this.viewCartBtn.addEventListener('click', this.onViewCartClick.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
    if (this.viewCartBtn) {
      this.viewCartBtn.removeEventListener('click', this.onViewCartClick.bind(this));
    }
  }
  
  onViewCartClick(e) {
    e.preventDefault();
    const cartUrl = window.routes?.cart_fetch_url || window.routes?.cart_url || '/cart';
    window.location.href = cartUrl;
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    
    // Show "View Cart" button only for success notifications
    if (this.viewCartBtn) {
      if (options.type === 'success') {
        this.viewCartBtn.style.display = 'block';
      } else {
        this.viewCartBtn.style.display = 'none';
      }
    }
    
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
    
    // Hide "View Cart" button when notification is hidden
    if (this.viewCartBtn) {
      this.viewCartBtn.style.display = 'none';
    }
  }
}
wrapGlobalClassPrototype(ToastNotification, 'ToastNotification');
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');

class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    try {
      this.isOpen = false;
      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele');
    } catch (e) {
      globalJsRollbar('CustomDrawer.constructor', e);
    }
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if(btn.dataset.for == 'collection-sorting'){
          this.classList.add('collection-sorting');
          setTimeout(() => {
            (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
          }, 500);
        }else{
          (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
        }
        
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(evt) {
    if(evt.code && evt.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.openedBy?.setAttribute('aria-expanded', true);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
  }

  closeDrawer() {
      this.isOpen = false;
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', false);
      setTimeout(() => {
        this.classList.remove('collection-sorting');
      }, 500);
      
      SiteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;

      // Close all open dropdowns when drawer is closed
      let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
      openDropdowns.forEach((ele) => {
        ele.classList.remove('open');
        ele.querySelector('[data-toggle="open"]')?.setAttribute('aria-expanded', false);
      });
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }
}
wrapGlobalClassPrototype(CustomDrawer, 'CustomDrawer');
customElements.define('custom-drawer', CustomDrawer);

const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    try {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
    } catch (e) {
      globalJsRollbar('swiperSliders.swiperslidechange', e);
    }
  });
});

let allNavItems = document.querySelectorAll('li[data-imglink]');
allNavItems.forEach((item) => {
  item.addEventListener('mouseenter', (evt) => {
    try {
    const imgLink = evt.currentTarget.getAttribute('data-imglink');
    if (imgLink) {
      // item.closest('.dropdown-menu').querySelector('[data-original]').classList.add('d-none');
      // item.closest('.dropdown-menu').querySelector('[data-imgreplace]').classList.remove('d-none');


       item.closest('.dropdown-menu').querySelector('.data-original').style.opacity = '0';
      item.closest('.dropdown-menu').querySelector('.data-imgreplace').style.opacity = '1';
      // let imageElement = item.closest('.dropdown-menu').querySelector('[data-imgreplace]');
       item.closest('.dropdown-menu').querySelector('.data-imgreplace').src = `${imgLink}`;
    }
    } catch (e) {
      globalJsRollbar('navImgLink.mouseenter', e);
    }
  });

   item.addEventListener('mouseleave', (evt) => {
    try {
    const imgLink = evt.currentTarget.getAttribute('data-imglink');
    if (imgLink) {
      // item.closest('.dropdown-menu').querySelector('[data-original]').classList.remove('d-none');
      // item.closest('.dropdown-menu').querySelector('[data-imgreplace]').classList.add('d-none');

       item.closest('.dropdown-menu').querySelector('.data-original').style.opacity = '1';
       item.closest('.dropdown-menu').querySelector('.data-imgreplace').style.opacity = '0';
    }
    } catch (e) {
      globalJsRollbar('navImgLink.mouseleave', e);
    }
  });
});

/**
  * Set root variable for header height
*/
(function updateTopinRoot(){
    try {
    let headerEle = document.querySelector('.section-header');
    if(headerEle != undefined){
      let headerHeight = headerEle.clientHeight;
      document.querySelector(':root').style.setProperty('--pe-header-height',`${headerHeight}px`);
    }
    } catch (e) {
      globalJsRollbar('updateTopinRoot', e);
    }
})()

// Set root variable for image height
// function setImageHeightVars() {
//   document.querySelectorAll(".js-watch-height").forEach(img => {
//     const target = img.closest(".target-this-height");
//     if (target) {
//       const height = img.getBoundingClientRect().height;
//       target.style.setProperty("--img-height", height + "px");
//     }
//   });
// }

//  const observer = new MutationObserver(() => {
//   document.querySelectorAll('swiper-slide').forEach(slide => {
//     console.log('slide==>>>>>',slide);
//     const img = slide.querySelector('img');
//     if(img){
//       if (img && img.complete) {
//         setImageHeightVars(img);
//       } else if (img) {
//         img.onload = () => setImageHeightVars(img);
//       }
//     }
//   });
// });

// let swiperparentdiv = document.querySelector('.swiper-wrapper__custom').closest('div');
// console.log('swiperparentdiv==>>>>>',swiperparentdiv);
// observer.observe(document.querySelector('#shopify-section-template--19357317595294__template_product_related_nyfzbP'), {
//   childList: true,
//   subtree: true
// });


// // run after load
// window.addEventListener("load", setImageHeightVars);
// // run again on resize
// window.addEventListener("resize", setImageHeightVars);


document.querySelectorAll('swiper-container').forEach((swiperEl, i) => {
  let swipercontainer = swiperEl.closest('section');
  
  if(!swipercontainer) return;

   const observer = new MutationObserver(() => {
      try {
      const slides = swipercontainer.querySelectorAll('swiper-slide');
      const firstSlide = slides[0];
      if (!firstSlide) return;
      const firstImg = firstSlide.querySelector('img');
      if (!firstImg) return;
      const target = firstImg.closest(".target-this-height");
      if (target) {
        const height = firstImg.getBoundingClientRect().height;
        target.style.setProperty("--img-height", height + "px");
      }
      } catch (e) {
        globalJsRollbar('swiperHeightMutationObserver', e);
      }
    });

    observer.observe(swipercontainer, {
      childList: true,
      subtree: true,
      attributes: true
    });
});

// Fix accessibility issue with Swiper buttons aria-controls
function fixSwiperButtonAccessibility() {
  try {
  document.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach(button => {
    const ariaControls = button.getAttribute('aria-controls');
    if (ariaControls) {
      const controlledElement = document.getElementById(ariaControls);
      if (!controlledElement) {
        button.removeAttribute('aria-controls');
      }
    }
  });
  } catch (e) {
    globalJsRollbar('fixSwiperButtonAccessibility', e);
  }
}

// Run on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    try {
      fixSwiperButtonAccessibility();
    } catch (e) {
      globalJsRollbar('fixSwiperButtonAccessibility.DOMContentLoaded', e);
    }
  });
} else {
  try {
    fixSwiperButtonAccessibility();
  } catch (e) {
    globalJsRollbar('fixSwiperButtonAccessibility.immediate', e);
  }
}

// Watch for dynamically added Swiper buttons
if (typeof MutationObserver !== 'undefined') {
  const swiperObserver = new MutationObserver((mutations) => {
    try {
    let shouldFix = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-controls') {
        shouldFix = true;
      } else if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList && (node.classList.contains('swiper-button-prev') || node.classList.contains('swiper-button-next'))) {
              shouldFix = true;
            } else if (node.querySelector && node.querySelector('.swiper-button-prev, .swiper-button-next')) {
              shouldFix = true;
            }
          }
        });
      }
    });
    
    if (shouldFix) {
      setTimeout(fixSwiperButtonAccessibility, 100);
    }
    } catch (e) {
      globalJsRollbar('swiperAriaMutationObserver', e);
    }
  });

  swiperObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-controls']
  });
}

// Suppress 403 errors from /pay/hop endpoint (Shopify app issue)
(function() {
  'use strict';
  
  // Store original console.error to filter out the specific error
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const errorMessage = args.join(' ');
    // Suppress 403 errors for /pay/hop endpoint
    if (errorMessage.includes('/pay/hop') && errorMessage.includes('403')) {
      return; // Don't log this error
    }
    // Log all other errors normally
    originalConsoleError.apply(console, args);
  };

  // Intercept fetch requests to suppress 403 errors for /pay/hop
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    
    // If it's a /pay/hop request, catch and suppress the error
    if (url.includes('/pay/hop')) {
      return originalFetch.apply(this, args).catch(error => {
        // Silently handle 403 errors for /pay/hop
        if (error.status === 403 || error.message?.includes('403')) {
          return Promise.resolve(new Response(null, { status: 403 }));
        }
        throw error;
      });
    }
    
    return originalFetch.apply(this, args).catch(error => {
      // Record the failing URL as Rollbar telemetry so it shows up in the item's timeline.
      // This only adds a breadcrumb: no new Rollbar item is created and the error is rethrown unchanged.
      try {
        if (window.Rollbar && typeof window.Rollbar.captureEvent === 'function') {
          window.Rollbar.captureEvent({ type: 'fetch', url: String(url), message: error && error.message }, 'error');
        }
      } catch (_) {}
      throw error;
    });
  };

  // Intercept XMLHttpRequest to suppress 403 errors for /pay/hop
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._url = url;
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };
  
  XMLHttpRequest.prototype.send = function(...args) {
    if (this._url && this._url.includes('/pay/hop')) {
      this.addEventListener('error', function(event) {
        // Suppress error for /pay/hop requests
        event.stopPropagation();
      }, true);
      
      this.addEventListener('load', function() {
        // Suppress 403 status for /pay/hop requests
        if (this.status === 403) {
          // Prevent error from propagating
          Object.defineProperty(this, 'status', {
            value: 200,
            writable: false
          });
        }
      });
    }
    
    return originalXHRSend.apply(this, args);
  };
})();

/**
 * Fix broken Swym wishlist images
 * Replaces images with "undefined", "/null", or "#" src with Keltec placeholder image
 * Handles wishlist grid images, cart popup images, and notification images
 */
(function fixSwymWishlistImages() {
  'use strict';

  let placeholderImageUrl = null;

  /**
   * Get placeholder image URL
   * Returns the Keltec placeholder image URL
   */
  function getPlaceholderImageUrl() {
    try {
      if (placeholderImageUrl) {
        return placeholderImageUrl;
      }
      placeholderImageUrl = 'https://ujx03f-w1.myshopify.com/cdn/shop/files/Placeholder-Image.svg?v=1752561075';
      return placeholderImageUrl;
    } catch (e) {
      globalJsRollbar('fixSwymWishlistImages.getPlaceholderImageUrl', e);
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect width="100" height="100" fill="%23EBF2FC"/%3E%3C/svg%3E';
    }
  }

  /**
   * Fix broken images with undefined src
   */
  function fixBrokenImages() {
    try {
    const wishlistImages = document.querySelectorAll('.swym-storefront-layout-grid-item-image, .swym-cc-sfl-popup-image, .swym-storefront-layout-notification-image, .swym-auto-wishlist-image-container img');
    
    wishlistImages.forEach((img) => {
      const src = img.getAttribute('src');
      
      // Check if src contains "undefined", "/null", "#", "[object Object]", or is actually undefined/null
      if (src && (
        src.includes('undefined') || 
        src === 'undefined' || 
        src.includes('/null') || 
        src === '#' || 
        src.trim() === '#' ||
        src.includes('[object Object]') ||
        src.includes('[object%20Object]') ||
        src.includes('%5Bobject%20Object%5D')
      )) {
        const placeholderUrl = getPlaceholderImageUrl();
        img.setAttribute('src', placeholderUrl);
        
        // Also handle error event in case the placeholder fails to load
        img.addEventListener('error', function onError() {
          // Try to use a data URI or fallback to a simple placeholder
          if (!this.src.includes('data:')) {
            this.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect width="100" height="100" fill="%23EBF2FC"/%3E%3C/svg%3E';
          }
          this.removeEventListener('error', onError);
        }, { once: true });
      }
    });
    } catch (e) {
      globalJsRollbar('fixSwymWishlistImages.fixBrokenImages', e);
    }
  }

  /**
   * Initialize observer and fix images
   */
  function init() {
    try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixBrokenImages);
    } else {
      fixBrokenImages();
    }

    const observer = new MutationObserver((mutations) => {
      try {
      let shouldFix = false;

        mutations.forEach((mutation) => {
          // Check for added nodes
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                // Check if the added node is a wishlist image or contains one
                if (node.classList && (
                  node.classList.contains('swym-storefront-layout-grid-item-image') || 
                  node.classList.contains('swym-cc-sfl-popup-image') || 
                  node.classList.contains('swym-storefront-layout-notification-image') ||
                  node.classList.contains('swym-auto-wishlist-image-container')
                )) {
                  shouldFix = true;
                } else if (node.querySelector && (
                  node.querySelector('.swym-storefront-layout-grid-item-image') || 
                  node.querySelector('.swym-cc-sfl-popup-image') || 
                  node.querySelector('.swym-storefront-layout-notification-image') ||
                  node.querySelector('.swym-auto-wishlist-image-container')
                )) {
                  shouldFix = true;
                }
              }
            });
          }

          // Check for attribute changes (src changes)
          if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
            const target = mutation.target;
            if (target && (
              (target.classList && (
                target.classList.contains('swym-storefront-layout-grid-item-image') || 
                target.classList.contains('swym-cc-sfl-popup-image') || 
                target.classList.contains('swym-storefront-layout-notification-image')
              )) ||
              (target.closest && target.closest('.swym-auto-wishlist-image-container'))
            )) {
              shouldFix = true;
            }
          }
        });

      if (shouldFix) {
        requestAnimationFrame(() => {
          fixBrokenImages();
        });
      }
      } catch (e) {
        globalJsRollbar('fixSwymWishlistImages.MutationObserver', e);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
    } catch (e) {
      globalJsRollbar('fixSwymWishlistImages.init', e);
    }
  }

  init();
})();